import refs from '../helpers/refs'
import site from '../helpers/site'

class CShare {
  constructor (el) {
    this.site = site()

    this.share = el
    this.$refs = refs(this.share)
    this.twitter = this.share.querySelector('div > div > a:nth-child(1)')
    this.facebook = this.share.querySelector('div > div > a:nth-child(2)')
    this.email = this.share.querySelector('div > div > a:nth-child(3)')
    this.link = this.share.querySelector('div > div > a:nth-child(4)')
    this.print = this.share.querySelector('div > a[href="/pdf-link"]')

    if (
      this.twitter &&
      this.facebook &&
      this.email &&
      this.link &&
      this.print
    ) {
      this.init()
    } else {
      console.error(
        'CShare: Could not find all elements. Twitter:',
        this.twitter,
        'Facebook:',
        this.facebook,
        'Email:',
        this.email,
        'Link:',
        this.link,
        'Print:',
        this.print
      )
    }
  }

  init () {
    const title = document.querySelector('[data-article-title]').dataset
      .articleTitle

    // Twitter
    this.twitter.href = `https://twitter.com/share?text=${title}&url=${window.location.href}`
    this.twitter.target = '_blank'
    // Facebook
    this.facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
    this.facebook.target = '_blank'
    // Email
    this.email.href = `mailto:?subject=${title}&body=${window.location.href}`
    this.email.target = '_blank'

    // Link
    this.link.removeAttribute('href')
    this.link.style.cursor = 'pointer'
    this.link.classList.add('relative')
    this.link.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href)

      // Add notification to link button container
      const notification = document.createElement('div')
      const classes =
        'absolute top-0 px-4 py-2 bg-charcoal z-10 text-white'.split(' ')
      notification.classList.add(...classes)
      notification.style =
        'margin-top: -2.1em;margin-left: -0.9em;animation: popUp 300ms ease-out;'
      notification.innerText = 'Copied!'
      this.link.appendChild(notification)

      // Remove notification after 1.5s
      setTimeout(() => {
        notification.remove()
      }, 1500)
    })
    // Add "Copied" popover to link button

    // Print
    this.print.removeAttribute('href')
    this.print.style.cursor = 'pointer'
    this.print.addEventListener('click', () => {
      window.print()
    })

    // Make ARIA labels more specific, Masterbuilt only
    if (this.site === 'masterbuilt') {
      const googlePlay = document.querySelector('.c-inline-cta a:first-of-type')
      const appleStore = document.querySelector('.c-inline-cta a:last-of-type')
      googlePlay.setAttribute(
        'aria-label',
        'Get it on Google Play'
      )
      appleStore.setAttribute(
        'aria-label',
        'Download from the App Store'
      )
    }
  }
}

window.addEventListener('load', () => {
  document.querySelectorAll('.c-share').forEach(el => new CShare(el))
})
